import { lazy } from "react";
import type { RouteObject } from "react-router-dom";

// Layout components (not lazy loaded as they're needed immediately)
import LayoutForms from "~/pages/providerWrapped/forms/LayoutForms";

// Lazy load form pages
const PageForms = lazy(() => import("~/pages/providerWrapped/forms/PageForms"));
const PageTemplateSlug = lazy(
  () => import("~/pages/providerWrapped/forms/[templateSlug]/PageTemplateSlug")
);
const PageStateSlug = lazy(
  () =>
    import(
      "~/pages/providerWrapped/forms/[templateSlug]/[stateSlug]/PageStateSlug"
    )
);
const PageEditableDocumentId = lazy(
  () =>
    import(
      "~/pages/providerWrapped/forms/[templateSlug]/[stateSlug]/[editableDocumentId]/PageEditableDocumentId"
    )
);

export const formsRoutes: RouteObject = {
  path: "forms",
  Component: LayoutForms,
  children: [
    {
      index: true,
      Component: PageForms,
    },
    {
      path: ":templateSlug",
      Component: PageTemplateSlug,
    },
    {
      path: ":templateSlug/:stateSlug",
      Component: PageStateSlug,
    },
    {
      path: ":templateSlug/:stateSlug/:editableDocumentId",
      Component: PageEditableDocumentId,
    },
  ],
};
